import axios from 'axios';
var url = 'https://backend.gruen-weiss.at/api/v1/';
var secret = '1wvcGZszF0IjoxpcLzWZybWJaWwijU0MjYzNci5N6LmF0IdRwcli';
const config = {
	headers: {
		'Content-Type': 'multipart/form-data'
	}
};

export const getHeaderFooter = async () => {

	var endpoint = 'headerfooter';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getPage = async (slug) => {

	var endpoint = 'page' + slug;
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getOnAir = async () => {

	var endpoint = 'on-air';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getPost = async (slug) => {

	var endpoint = 'post' + slug;
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getAds = async () => {

	config.headers.secret = secret;

	var data = new FormData();

	var endpoint = 'ads';
	var endpoint = url + endpoint;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getAdvent = async (slug) => {

	config.headers.secret = secret;

	var data = new FormData();

	var endpoint = 'advent?slug=' + slug;
	var endpoint = url + endpoint;

	try {
		const response = await axios.get(endpoint, config);


		console.log(response)
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getPosts = async (posttypes, number) => {

	config.headers.secret = secret;

	var data = new FormData();

	var endpoint = 'posts';
	var endpoint = url + endpoint;

	data.append('type', 'website');

	posttypes.forEach((posttype, index) => {
		if (posttype == 'news') {
			data.append(`posttype[${index}]`, 'post');
		}
		if (posttype == 'events') {
			data.append(`posttype[${index}]`, 'event');
		}	
		if (posttype == 'werbung') {
			data.append(`posttype[${index}]`, 'ads');
		}		
		if (posttype == 'jobs') {
			data.append(`posttype[${index}]`, 'job');
		}	
		if (posttype == 'gewinnspiel') {
			data.append(`posttype[${index}]`, 'competition');
		}	
	});

	if (number) {
		data.append('number', number);
	}

	try {
		const response = await axios.post(endpoint, data, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const sendFormApi = async(name, email, phone, city, artist, song, subject, message, time_open, time_sent, type) => {

	config.headers.secret = secret;

	var data = new FormData();

	var endpoint = 'send-form';
	var endpoint = url + endpoint;

	data.append('name', name);
	data.append('email', email);
	data.append('phone', phone);
	data.append('city', city);
	data.append('artist', artist);
	data.append('song', song);
	data.append('subject', subject);
	data.append('message', message);
	data.append('time_open', time_open);
	data.append('time_sent', time_sent);
	data.append('type', type);

	try {
		const response = await axios.post(endpoint, data, config);
		return response;
	} catch (error) {
		return error.response;
	}

}


export const sendFreeFormApi = async(fields) => {

    if (fields.form) {
        // config and secret must be defined in your file scope
        config.headers.secret = secret;

        var data = new FormData();

        var endpoint = 'send-free-form';
        endpoint = url + endpoint; // Ensure 'url' is defined

        // 1. Add the Form ID separately
        data.append('form', fields.form);

        // 2. Separate Files from Text
        // We create a temporary object to hold text values for JSON.stringify
        let textData = {};

        Object.keys(fields).forEach(key => {
            if (key === 'form') return; // Skip form ID (already added)

            const value = fields[key];

            if (value instanceof File) {
                // --- CASE A: It is a File ---
                // Append the actual binary file to FormData so PHP $_FILES sees it
                data.append(key, value);
                
                // ALSO add the filename to the textData. 
                // This ensures your Backend validation ("Field is required") passes
                // because it sees a string instead of nothing.
                textData[key] = `Datei: ${value.name}`; 
            } else {
                // --- CASE B: It is Text/Date/Select ---
                textData[key] = value;
            }
        });

        // 3. Append the text fields as a JSON string
        // The backend will decode this to check validation requirements
        data.append('data', JSON.stringify(textData));

        try {
            // Axios automatically sets Content-Type to multipart/form-data 
            // when it detects a FormData object.
            const response = await axios.post(endpoint, data, config);
            return response;
        } catch (error) {
            return error.response;
        }
    } else {
        alert('Es ist ein Fehler aufgetreten!');
    }
}

export const getTeam = async () => {

	var endpoint = 'team';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getVotings = async () => {

	var endpoint = 'votings';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const sendVote = async (unique, song) => {

	var data = new FormData();

	var endpoint = 'votings';
	var endpoint = url + endpoint;

	data.append('unique', unique);
	data.append('song', song);

	try {
		const response = await axios.post(endpoint, data, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getTeamMember = async (slug) => {

	var endpoint = 'team/' + slug;
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getTraffic = async () => {
	var endpoint = 'traffic-filtered';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}
};

export const getProgram = async () => {
	var endpoint = 'program';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}
};

export const getFrequencies = async (slug) => {

	var endpoint = 'frequencies';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getAllFrequencies = async (slug) => {

	var endpoint = 'frequencies-all';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getRadiothek = async (slug) => {

	var endpoint = 'radiothek';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getForm = async (id) => {

	var endpoint = 'form/' + id;
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};


// export const getCurrentPlaying = async (slug) => {

// 	var endpoint = 'currentplaying';
// 	var endpoint = url + endpoint;

// 	config.headers.secret = secret;

// 	try {
// 		const response2 = await axios.get(endpoint, config);
// 		return response2;
// 	} catch (error1) {
// 		return { error1 };
// 	}
// 	try {
// 		const response1 = await axios.get('https://gruen-weiss.at/ta/onair.json');
// 		return response1;
// 	} catch (error1) {
// 		// try {
// 		// 	const response2 = await axios.get(endpoint, config);
// 		// 	return response2;
// 		// } catch (error2) {
// 		// 	return { error1, error2 };
// 		// }
// 	}

// };

// Hauptprogramm + Digitalradios (Sidechannels). Schlüssel = Channel-Kürzel der Titel-API.
// Die aktuelle Liste kommt aus /streams.json (Name, Stream, onair, Titelsuche, Icon) – siehe loadStreamsConfig().
// Die ID 'rgw' steht für das Hauptprogramm und muss in der Datei erhalten bleiben.
const TA = 'https://t.gruen-weiss.at/data/ta';

// Herkunftskennung für die Stream-Statistik: Website = FLID 1 (App = 2)
const STREAM_FLID = '1';
const withFlid = (streamUrl) => (/[?&]FLID=/i.test(streamUrl) ? streamUrl : `${streamUrl}${streamUrl.includes('?') ? '&' : '?'}FLID=${STREAM_FLID}`);

// Eingebauter Ersatz, falls /streams.json nicht geladen werden kann
const DEFAULT_STREAMS_CONFIG = {
	headline: 'Radio Grün Weiss Streams',
	streams: [
		{ id: 'rgw', name: 'Radio Grün Weiß', tabName: 'Hauptprogramm', stream: 'https://live.gruen-weiss.at/rgw.mp3', onair: `${TA}/onair.json`, titlesearch: `${TA}/abfrage.php`, icon: '/icon/channel-rgw.svg' },
		{ id: 'schl', name: 'Mehr Schlager', tabName: 'Mehr Schlager', stream: 'https://live.gruen-weiss.at/rgw-schl.mp3', onair: `${TA}/schl/onair.json`, titlesearch: `${TA}/abfrage.php?ch=schl`, icon: '/icon/channel-schl.svg' },
		{ id: 'aufg', name: "Aufg'spielt wird", tabName: "Aufg'spielt wird", stream: 'https://live.gruen-weiss.at/rgw-aufg.mp3', onair: `${TA}/aufg/onair.json`, titlesearch: `${TA}/abfrage.php?ch=aufg`, icon: '/icon/channel-aufg.svg' },
		{ id: 'kult', name: 'Kulthits', tabName: 'Kulthits', stream: 'https://live.gruen-weiss.at/rgw-kult.mp3', onair: `${TA}/kult/onair.json`, titlesearch: `${TA}/abfrage.php?ch=kult`, icon: '/icon/channel-kult.svg' },
	],
};

// Icon: SVG-Text wird als Bild (data-URI) eingebunden – nie als HTML, damit nichts darin ausgeführt wird.
// Erlaubt sind auch Pfade/URLs; sonst das mitgelieferte Icon.
const toIconSrc = (s) => {
	const icon = typeof s.icon === 'string' ? s.icon.trim() : '';
	if (icon.startsWith('<svg')) return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icon)}`;
	if (/^(https?:\/\/|\/|data:image\/)/.test(icon)) return icon;
	if (typeof s.iconPng === 'string' && s.iconPng.startsWith('data:image/')) return s.iconPng;
	return `/icon/channel-${['rgw', 'schl', 'aufg', 'kult'].includes(s.id) ? s.id : 'rgw'}.svg`;
};

const isValidStream = (s) => s && typeof s.id === 'string' && s.id && typeof s.name === 'string' && typeof s.stream === 'string' && typeof s.onair === 'string';

// Live-Registry: wird bei neuer Konfiguration inhaltlich ersetzt (Reihenfolge = Reihenfolge in der Datei)
export const CHANNELS = {};
export const STREAMS = { headline: DEFAULT_STREAMS_CONFIG.headline };

export const applyStreamsConfig = (config) => {
	const streams = Array.isArray(config?.streams) ? config.streams.filter(isValidStream) : [];
	if (!streams.some(s => s.id === 'rgw')) return false;

	Object.keys(CHANNELS).forEach((key) => delete CHANNELS[key]);
	streams.forEach((s) => {
		if (CHANNELS[s.id]) return;
		CHANNELS[s.id] = {
			name: s.name,
			tabName: s.tabName || s.name,
			icon: toIconSrc(s),
			stream: withFlid(s.stream),
			onair: s.onair,
			titlesearch: s.titlesearch || `${TA}/abfrage.php${s.id === 'rgw' ? '' : `?ch=${s.id}`}`,
		};
	});
	STREAMS.headline = typeof config.headline === 'string' && config.headline ? config.headline : DEFAULT_STREAMS_CONFIG.headline;
	return true;
};

applyStreamsConfig(DEFAULT_STREAMS_CONFIG);

// Lädt /streams.json (gleiche Domain wie die Website). true = neue Konfiguration übernommen
export const loadStreamsConfig = async () => {
	try {
		const response = await axios.get('/streams.json', { headers: { 'Cache-Control': 'no-cache' } });
		return applyStreamsConfig(typeof response.data === 'string' ? JSON.parse(response.data) : response.data);
	} catch (error) {
		console.error('Error loading streams.json', error);
		return false;
	}
};


// The currently running entry of an onair.json list
export const getPlayingEntry = (list) => {
	if (!Array.isArray(list)) return null;
	return list.find(item => item.sequence === 'playing') || list[2] || null;
};

// dateTime: '' or '?z=YYYY-MM-DD%20HH:MM'; ch: channel key (rgw = Hauptprogramm)
export const getCurrentSongs = async (dateTime, ch = 'rgw') => {
	const base = (CHANNELS[ch] || CHANNELS.rgw).titlesearch;
	const query = new URLSearchParams(dateTime ? dateTime.replace(/^\?/, '') : '').toString();

	try {
		const response = await axios.get(base + (query ? (base.includes('?') ? '&' : '?') + query : ''));
		return response;
	} catch (error1) {
		return { error1 };
	}
};

export const getCurrentPlayingLive = async (ch = 'rgw') => {
	const channel = CHANNELS[ch] || CHANNELS.rgw;
	try {
		const response = await axios.get(channel.onair);
		return response;
	} catch (error1) {
		return { error1 };
	}
};

export const getToptipp = async (id) => {

	var endpoint = 'toptipp/' + id;
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getTopTipps = async () => {

	var endpoint = 'toptipps';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	var data = new FormData();

	try {
		const response = await axios.post(endpoint, data, config);
		return response;
	} catch (error) {
		return error.response;
	}

};

export const getSentPositions = async () => {

	var endpoint = 'receive-livestatus';
	var endpoint = url + endpoint;

	config.headers.secret = secret;

	try {
		const response = await axios.get(endpoint, config);
		return response;
	} catch (error) {
		return error.response;
	}

};


